import styled, { css, keyframes } from 'styled-components'

const showContent = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

type WrapperProps = {
  buttonConverter: boolean
  type: string
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, buttonConverter, type }) => css`
    padding: 16px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    position: relative;

    -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);

    width: calc(50% - 16px);
    min-width: 360px;

    display: flex;
    justify-content: space-between;

    transition: all ease-in-out 400ms;
    animation: ${showContent} 400ms;

    .detalhe-link {
      position: absolute;
      bottom: 16px;
      right: 16px;

      button {
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 400;
        text-decoration: underline;
        background: transparent;
        border: none;
        cursor: pointer;
      }
    }

    ${type === 'Negociação aguardando avaliação' ||
    type === 'Em Avaliação' ||
    type === 'Cotação com Pedido'
      ? css`
          border-left: 4px solid #ffbc00;
        `
      : null}

    ${type === 'Negociação Avaliada' || type === 'Avaliada'
      ? css`
          border-left: 4px solid ${theme.colors.success};
        `
      : null}

    ${type === 'Cancelada' &&
    css`
      border-left: 4px solid ${theme.colors.error};
    `}

    ${type === 'Vencida' &&
    css`
      border-left: 4px solid ${theme.colors.error};
    `}

    ${type === 'Válida' &&
    css`
      border-left: 4px solid ${theme.colors.success};
    `}

    ${type === 'Cotação com Pedido' ||
    type === 'Negociação com Pedido' ||
    type === 'Convertida'
      ? css`
          border-left: 4px solid #afaeae;
        `
      : null}

    @media (max-width: 800px) {
      min-width: 300px;
      width: 100%;
    }

    @media (max-width: 500px) {
      max-width: 100%;
      flex-direction: column;
      gap: 16px;

      .detalhe-link {
        ${!!buttonConverter &&
        css`
          bottom: 72px;
        `}
      }
    }
  `}
`

export const CardInfo = styled.div`
  p {
    margin-bottom: 4px;
    font-size: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    text-decoration: underline;
  }

  p.numero {
    font-size: 16px;
  }

  strong {
    font-weight: 600;
  }
`

type TagProps = {
  type: string
}

export const Tag = styled.div<TagProps>`
  ${({ theme, color, type }) => css`
    padding: 4px 8px;
    font-size: 13px;
    border-radius: 4px;
    color: #fff;
    font-weight: 600;
    top: 16px;
    right: 16px;
    max-height: 24px;

    position: absolute;

    ${color === 'green' &&
    css`
      background-color: #27ae60;
    `}

    ${color === 'red' &&
    css`
      background-color: #fa3434;
    `}

    ${type === 'Negociação aguardando avaliação' ||
    type === 'Em Avaliação' ||
    type === 'Cotação com Pedido'
      ? css`
          color: #ffffff;
          background: #ffbc00;
        `
      : null}

    ${type === 'Negociação Avaliada' || type === 'Avaliada'
      ? css`
          color: #ffffff;
          background: ${theme.colors.success};
        `
      : null}

    ${type === 'Cancelada' &&
    css`
      color: #ffffff;
      background: ${theme.colors.error};
    `}

    ${type === 'Vencida' &&
    css`
      color: #ffffff;
      background: ${theme.colors.error};
    `}

    ${type === 'Cotação' ||
    type === 'Cotação com Pedido' ||
    type === 'Negociação com Pedido' ||
    type === 'Convertida'
      ? css`
          color: #ffffff;
          background: #afaeae;
        `
      : null}

    ${type === 'waiting' &&
    css`
      display: none;
    `}

    ${type === null &&
    css`
      display: none;
    `}
  `}
`

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`
export const CardButton = styled.button`
  ${({ theme }) => css`
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
    padding: 8px 16px;
    text-align: center;
    transition: ${theme.transition.default};
    -webkit-transition: all 400ms;
    -moz-transition: all 400ms;

    border-radius: 4px;
    border: 2px solid transparent;
    background: ${theme.colors.cart};
    color: ${theme.colors.white};
    cursor: pointer;

    height: 36px;

    &:hover {
      background: #1e8449;
    }

    &.mobile {
      width: 100%;
      margin: 16px 0 8px;
    }
  `}
`
